import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const value = useMemo(() => {
    const login = async (email, password) => {
      try {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return { ok: true };
      } catch (e) {
        return { ok: false, error: formatApiError(e.response?.data?.detail) };
      }
    };

    const register = async (payload) => {
      try {
        const { data } = await api.post("/auth/register", payload);
        setUser(data);
        return { ok: true };
      } catch (e) {
        return { ok: false, error: formatApiError(e.response?.data?.detail) };
      }
    };

    const logout = async () => {
      try {
        await api.post("/auth/logout");
      } catch (e) {
        // ignore — local state is cleared regardless
      }
      setUser(false);
    };

    return { user, login, register, logout };
  }, [user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
